export default (val) => {
  if (val === 'null' || val === 'undefined' || val === 'false') {
    return false;
  }

  return val;
};
